import { Grid } from '@mui/material'
import { formatCurrency } from 'components/DataGrid/operators/formatNumbers'
import StatCard from './StatCard'

const RenderValues = ({
  activeContractValue,
  activeMRR,
  mrrAtRisk30d,
  activeProductRevenue,
}: {
  activeContractValue: number
  activeMRR: number
  mrrAtRisk30d: number
  activeProductRevenue: number
}) => {
  return (
    <>
      <Grid item xs={6} md={3}>
        <StatCard
          label="Active Contract Value"
          value={formatCurrency(activeContractValue)}
          hint="Sum of totals for active deals you own"
          highlight
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <StatCard
          label="Active MRR"
          value={formatCurrency(activeMRR)}
          hint="Sum of monthly totals for active deals you own"
          highlight
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <StatCard
          label="MRR at Risk ≤30d"
          value={formatCurrency(mrrAtRisk30d)}
          hint="Deals with any product ending in 30 days"
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <StatCard
          label="Active Product Revenue"
          value={formatCurrency(activeProductRevenue)}
          hint="Aggregate total revenue of active products"
        />
      </Grid>
    </>
  )
}
export default RenderValues
